import React, { useEffect, useState } from 'react';
import { View } from 'react-native';
import Root from './Root';
import FontHandler from './src/Handlers/FontHandler';
import './index.css';

/**
 * Application entrypoint for mobile.
 * Only add any platform dependant imports here.
 * @returns JSX Element.
 */
export default function App(): JSX.Element
{
  const [loaded, setLoaded] = useState(false);

  useEffect(() =>
  {
    (async (): Promise<void> =>
    {
      setLoaded(false);
      await FontHandler.initialise();
      setLoaded(true);
    })();
  }, []);

  useEffect(() =>
  {
    // History.scrollRestoration seems to be supported on Chrome, whereas
    // window.onbeforeunload isnt.
    // Forces the page to scroll to the top before refreshing so
    // it is able to calculate the content height correctly.
    if (history.scrollRestoration)
    {
      history.scrollRestoration = 'manual';
    }
    else
    {
      window.onbeforeunload = (): void =>
      {
        window.scrollTo(0, 0);
      };
    }
  }, []);

  if (!loaded)
  {
    return <View />;
  }

  return <Root />;
}
